import {
  loginAdmin,
  verifyTotp,
  verifyEmailCode,
  changePasswordLogin,
} from "@/api/admin";

const TOKEN_KEY = "admin_token";
const USER_KEY = "admin_user";

function loadUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export default {
  namespaced: true,
  state: () => ({
    token: localStorage.getItem(TOKEN_KEY) || "",
    authenticated: !!localStorage.getItem(TOKEN_KEY),
    user: loadUser(),
    logoutReason: "",
  }),
  getters: {
    hasPermission: (state) => (perm) => {
      if (!state.user) return false;
      // admin role always has all permissions
      if (state.user.role === "admin") return true;
      if (!state.user.permissions || !state.user.permissions.length)
        return false;
      return state.user.permissions.includes(perm);
    },
    userRole: (state) => state.user?.role || "editor",
    userName: (state) => state.user?.username || "",
    userPermissions: (state) => state.user?.permissions || [],
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      state.authenticated = !!token;
      if (token) {
        localStorage.setItem(TOKEN_KEY, token);
      } else {
        localStorage.removeItem(TOKEN_KEY);
      }
    },
    SET_USER(state, user) {
      state.user = user;
      if (user) {
        localStorage.setItem(USER_KEY, JSON.stringify(user));
      } else {
        localStorage.removeItem(USER_KEY);
      }
    },
    CLEAR_USER(state) {
      state.user = null;
      localStorage.removeItem(USER_KEY);
    },
    SET_LOGOUT_REASON(state, reason) {
      state.logoutReason = reason || "";
    },
    CLEAR_LOGOUT_REASON(state) {
      state.logoutReason = "";
    },
  },
  actions: {
    async login({ commit }, { username, password, captchaToken, captchaCode }) {
      const res = await loginAdmin(
        username,
        password,
        captchaToken,
        captchaCode,
      );
      const data = res.data.data;
      if (data.token) {
        commit("SET_TOKEN", data.token);
        commit("SET_USER", {
          username: data.username,
          role: data.role,
          permissions: data.permissions || [],
        });
      }
      return data;
    },
    async verifyTotp({ commit }, { tempToken, totpCode }) {
      const res = await verifyTotp(tempToken, totpCode);
      const data = res.data.data;
      if (data.token) {
        commit("SET_TOKEN", data.token);
        commit("SET_USER", {
          username: data.username,
          role: data.role,
          permissions: data.permissions || [],
        });
      }
      return data;
    },
    async verifyEmailCode({ commit }, { tempToken, emailCode }) {
      const res = await verifyEmailCode(tempToken, emailCode);
      const data = res.data.data;
      if (data.token) {
        commit("SET_TOKEN", data.token);
        commit("SET_USER", {
          username: data.username,
          role: data.role,
          permissions: data.permissions || [],
        });
      }
      return data;
    },
    async changePassword({ commit }, { tempToken, newPassword }) {
      const res = await changePasswordLogin(tempToken, newPassword);
      const data = res.data.data;
      if (data.token) {
        commit("SET_TOKEN", data.token);
        commit("SET_USER", {
          username: data.username,
          role: data.role,
          permissions: data.permissions || [],
        });
      }
      return data;
    },
    logout({ commit }, reason) {
      commit("SET_TOKEN", "");
      commit("CLEAR_USER");
      if (reason) {
        commit("SET_LOGOUT_REASON", reason);
      }
    },
  },
};
